<div class="points" v-if="item.all_points">
    <div>
        <div v-if="item.negative_points === 0" class="text-green d-inline">Подходит</div>
        <div v-else class="text-red d-inline">Не подходит</div>
        (<div class="all-points text-green d-inline">{{formatPoints(item.all_points)}}</div>
        <div class="negative-points text-red d-inline" v-if="item.negative_points !== 0">, {{formatPoints(item.negative_points)}}</div>)
    </div>

</div>
